import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { REPORTS_PERMISSION_CODES } from 'permissions/constants/reportsPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { REPORTS_PERMISSION_CODES };

const usePermissionsReports = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.REPORTS),
      canAccessScoringByLawyers: hasPermission(
        REPORTS_PERMISSION_CODES.SCORING_BY_LAWYERS
      ),
      canViewScoringByLawyersSection: hasPermission(
        REPORTS_PERMISSION_CODES.SCORING_BY_LAWYERS_VIEW_SECTION
      ),
      canDownloadScoringByLawyersExcel: hasPermission(
        REPORTS_PERMISSION_CODES.SCORING_BY_LAWYERS_DOWNLOAD_EXCEL
      ),
      canAccessTemplateUsage: hasPermission(
        REPORTS_PERMISSION_CODES.TEMPLATE_USAGE
      ),
      canViewTemplateUsageSection: hasPermission(
        REPORTS_PERMISSION_CODES.TEMPLATE_USAGE_VIEW_SECTION
      ),
      canDownloadTemplateUsageExcel: hasPermission(
        REPORTS_PERMISSION_CODES.TEMPLATE_USAGE_DOWNLOAD_EXCEL
      ),
      canAccessDetectionAndMonitoring: hasPermission(
        REPORTS_PERMISSION_CODES.DETECTION_AND_MONITORING
      ),
      canViewDetectionAndMonitoringSection: hasPermission(
        REPORTS_PERMISSION_CODES.DETECTION_AND_MONITORING_VIEW_SECTION
      ),
      canDownloadDetectionAndMonitoringExcel: hasPermission(
        REPORTS_PERMISSION_CODES.DETECTION_AND_MONITORING_DOWNLOAD_EXCEL
      ),
      canManageDetectionAndMonitoring: hasPermission(
        REPORTS_PERMISSION_CODES.DETECTION_AND_MONITORING_MANAGE
      ),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsReports;
